import React, { useRef } from "react";
import { useDialog } from "react-aria";

export function Dialog({ title, children, ...props }) {
  let ref = useRef();
  let { dialogProps } = useDialog(props, ref);

  return (
    <div {...dialogProps} ref={ref}>
      {children}
    </div>
  );
}
